import { useState } from 'react';
import type { Children } from '@repo/shared/types';

import { AgreementAndApprovalsContext } from './agreement-and-approvals-context';

export function AgreementAndApprovalsContextProvider({ children }: Children) {
  const [isAdvancePaymentCalculating, setIsAdvancePaymentCalculating] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <AgreementAndApprovalsContext.Provider
      value={{
        isAdvancePaymentCalculating,
        setIsAdvancePaymentCalculating,
        isEditMode,
        setIsEditMode,
      }}
    >
      {children}
    </AgreementAndApprovalsContext.Provider>
  );
}
